import {Component, OnDestroy, OnInit, ViewChild, EventEmitter, Output, Input} from '@angular/core';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Offset} from '../../../models/Offset';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import {ChargesScartoService} from './service-charges-scarto/charges-scarto.service';
import {ScartiConsuntivoChargesModel} from '../../../models/ScartiConsuntivoChargesModel';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {ProviderAnagrafService} from '../../general-services/service-provider-anagraf/provider-anagraf.service';
import { Router } from '@angular/router';
import {ProviderModel} from "../../../models/ProviderModel";

@Component({
  selector: 'app-charges-waste',
  templateUrl: './waste-charges.component.html',
  styleUrls: ['./waste-charges.component.scss']
})
export class WasteChargesComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  getFirtsYearSubscribe: Subscription;
  getFirtsYearObservable: Observable<any>;
  getFirstProviderObservable: Observable<any>;
  numAnnoMeseData: any;

  displayedColumns: Array<string>;
  dataSource: any;
  isMocked: boolean;
  showFilter: boolean;
  listData: MatTableDataSource<any>;
  offset: Offset;
  numAnnoMese: any;
  filter: ScartiConsuntivoChargesModel;

  isConsumptiveWasteSection: boolean;
  selectedRowIndex: number;

  providerSelected: ProviderModel;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() reportSection?: boolean;
  @Output() elementSelected = new EventEmitter();



  constructor(private numAnnoMeseService: NumAnnoMeseService,
              private providerService: ProviderAnagrafService,
              private chargesScartoService: ChargesScartoService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.providerSelected = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;

    if (this.providerSelected.description === this.PROVIDER_IBM) {
      this.displayedColumns = ['numAnnoMeseRif', 'providerCod', 'regionCod',
        'localCustomerCod', 'contractCod', 'resourcesUnitCod',
        'designedServiceCod', 'charge', 'errors', 'actions'];
    } else {
      this.displayedColumns = ['billedMonth', 'numAnnoMeseRif', 'providerCod',
        'regionCod', 'localCustomerCod', 'contractCod',
        'resourcesUnitCod', 'designedServiceCod', 'numAnnoMeseAcceptance', 'residualMonth',
        'percUse', 'applicableRate', 'charge', 'errors', 'actions'];
    }
  }

  ngOnInit() {
    this.isConsumptiveWasteSection = this.returnIsContractSection(this.router.url);
    this.selectedRowIndex = -1;
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.SCARTI_CONSUNTIVO_CHARGES_OFFSET);
    this.filter = new ScartiConsuntivoChargesModel();
    this.getFirtsYearObservable = this.numAnnoMeseService.getAllMonth().pipe();
    this.getFirstProviderObservable = this.providerService.getAll(this.providerService.baseUrl, null).pipe();
    this.manageForkJoin(this.getFirtsYearObservable, this.offset);
  }

  manageForkJoin(getFirtsYearSubscribe: Observable<any>, offset: Offset) {
    forkJoin([getFirtsYearSubscribe]).subscribe(
      (resultFork: any) => {

        this.numAnnoMeseData = resultFork[0];
        const numAnnoMese = resultFork[0] ? resultFork[0][0] : null;

        this.filter.numAnnoMese = numAnnoMese;
        if (!this.reportSection) {
          this.showFilter = false;
          this.getDataPage(this.offset, this.filter);
        } else {
          this.showFilter = true;
        }      }, error => {
        console.log(error);
        this.loaderService.display(false);
      });
  }

  getDataPage(offset: Offset, filter: ScartiConsuntivoChargesModel) {
    this.getPageSubscribe = this.chargesScartoService.getPage(offset, filter)
      .subscribe(
        (resultPage: any) => {
          this.dataSource = resultPage.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = resultPage.totalElements;
          this.listData.sort = this.sort;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    const consuntivoCharges = this.dataSource.find(data => data.id === id) as ScartiConsuntivoChargesModel;
    const list: GenericArray[] = [
      {id: 'Month', value: this.toCustomStringAnnoMese(consuntivoCharges.numAnnoMese)},
      {id: 'Reference Month', value: this.toCustomStringAnnoMese(consuntivoCharges.numAnnoMeseRif)},
      {id: 'Region Cod', value: this.toCustomString(consuntivoCharges.regionCod)},
      {id: 'Local Customer Cod', value: this.toCustomString(consuntivoCharges.localCustomerCod)},
      {id: 'Contract Type Cod', value: this.toCustomString(consuntivoCharges.contractCod)},
      {id: 'Resource Unit Cod', value: this.toCustomString(consuntivoCharges.resourcesUnitCod)},
      {id: 'Errors', value: this.toCustomString(consuntivoCharges.errors)},
      {id: 'SL1 Cod', value: this.toCustomString(consuntivoCharges.designedServiceCod)},
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    let tmpOffset = new Offset(event.pageSize, event.pageIndex);
    tmpOffset = this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.SCARTI_CONSUNTIVO_CHARGES_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);

  }

  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    if (!this.reportSection) {
      this.showFilter = !this.showFilter;
    }
  }
}
